import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import { getOptionLabel } from "common/enums";
import Collapse from "./Collapse";

const FireFightingPumpDetailView = ({
  fireFightingPumps,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Pump Build Type",
        key: "pumpBuildType",
        renderField: (value) =>
          getOptionLabel("firePumpBuildTypeEnum", value) ?? "-",
      },
      {
        name: "Pump Type",
        key: "type",
        renderField: (value) =>
          getOptionLabel("fireFightingPumpTypeEnum", value) ?? "-",
      },
      {
        name: "Number of Pump",
        key: "numberOfPump",
        isRequired: true,
      },
      {
        name: "Head (Mtrs)",
        key: "head",
        isRequired: true,
      },
      {
        name: "Discharge (LPM)",
        key: "discharge",
        isRequired: true,
      },
      {
        name: "Auto Start Pressure (kg/cm2)",
        key: "autoStartPressure",
        isRequired: true,
      },
      {
        name: "Auto Stop Pressure (kg/cm2)",
        key: "autoStopPressure",
        isRequired: true,
      },
      {
        name: "KW / HP",
        key: "kwOrHp",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title="Fire Fighting Pump Details" isExpandable={isExpandable}>
        {fireFightingPumps.map((fireFightingPump, index) => (
          <Fragment key={fireFightingPump.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Fire Fighting Pump") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(fireFightingPump, key, "");

                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(fireFightingPump, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

FireFightingPumpDetailView.propTypes = {
  fireFightingPumps: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(FireFightingPumpDetailView);
